import { Minus, Plus, Trash2 } from "lucide-react";
import { Button } from "../ui/button";
import { yen } from "../../lib/api";
import { useI18n } from "../../lib/i18n";

/** Daftar item di keranjang online beserta pengatur jumlah. */
export const CartItems = ({ items, setQty }) => {
  const { t } = useI18n();
  return (
    <div className="space-y-2 max-h-80 overflow-y-auto">
      {items.length === 0 && (
        <p className="text-sm text-muted-foreground py-4 text-center">{t("empty_cart")}</p>
      )}
      {items.map((it) => (
        <div
          key={it.product_id}
          data-testid={`online-cart-item-${it.product_id}`}
          className="bg-gray-50 rounded-xl p-2.5 space-y-2"
        >
          <p className="text-sm leading-snug break-words" title={it.name}>
            {it.name}
          </p>
          <div className="flex items-center gap-2">
            <Button
              size="icon"
              variant="outline"
              className="h-8 w-8 shrink-0"
              data-testid={`online-dec-${it.product_id}`}
              onClick={() => setQty(it.product_id, it.qty - 1)}
            >
              <Minus size={13} />
            </Button>
            <span className="num w-7 text-center text-sm">{it.qty}</span>
            <Button
              size="icon"
              variant="outline"
              className="h-8 w-8 shrink-0"
              data-testid={`online-inc-${it.product_id}`}
              onClick={() => setQty(it.product_id, it.qty + 1)}
            >
              <Plus size={13} />
            </Button>
            <span className="num text-sm ml-auto text-right">{yen(it.price * it.qty)}</span>
            <Button
              size="icon"
              variant="ghost"
              className="h-8 w-8 shrink-0 text-destructive"
              data-testid={`online-remove-${it.product_id}`}
              onClick={() => setQty(it.product_id, 0)}
            >
              <Trash2 size={13} />
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
};
